export default __webpack_public_path__ + "static/media/IMG_0358 copie.13986d3b.jpg";